<div class="dropdown" ngbDropdown display="static" (openChange)="onDropdownToggle($event)" #caseSelector="ngbDropdown">
  <button class="btn btn-outline-primary ps-4 w-100" id="dropdownMenuButton" ngbDropdownToggle>
    {{ label || 'Select case' }}
  </button>
  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" ngbDropdownMenu>
    <div class="mb-2 filter-container" [ngClass]="{ 'd-none': !showFilter }">
      <input
        #filterInput
        type="text"
        class="form-control"
        [(ngModel)]="filterText"
        placeholder="Filter on client or case name"
        (ngModelChange)="onFilterChange()"
        (keydown)="onKeyDownFilterInput($event)" />
      <a href="#" (click)="clearFilter()" class="clear-button" *ngIf="searchTerm$ | async">
        <i class="bi bi-x-lg"></i>
      </a>
    </div>
    <div class="items-list" #itemsList>
      <tx-loader-wrapper [isLoading]="loading">
        <div *ngFor="let contact of filteredContactsAndCases; let contactIndex = index">
          <div class="dropdown-header d-flex align-items-center gap-4">
            <a
              href="#"
              (click)="toggleContact(contact)"
              (keydown)="onKeyDownContact($event, contact, contactIndex)"
              [id]="'contact-' + contact.ctcID"
              class="d-flex align-items-center gap-2 flex-fill text-decoration-none">
              <i class="bi bi-plus-square" *ngIf="!contact.expanded"></i>
              <i class="bi bi-dash-square" *ngIf="contact.expanded"></i>
              <span class="text-body">
                <ng-container *ngIf="!showFilter">Cases for&nbsp;</ng-container>
                <strong>{{ contact.lastName }}, {{ contact.firstName }}</strong>
              </span>
            </a>

            <a href="#" *ngIf="!showFilter" class="d-inline" (click)="showAllClients()">Select other client</a>
          </div>

          <ng-container *ngIf="contact.expanded">
            <button
              *ngFor="let case of contact.cases; let caseIndex = index"
              [id]="'case-' + case.casID"
              class="dropdown-item"
              [ngClass]="case.casID === selectedCase?.casID ? 'active' : ''"
              (click)="onCaseClicked(contact, case, $event)"
              (keydown)="onKeyDownCase($event, contact, contactIndex, case, caseIndex)">
              {{ case.description }}
            </button>
          </ng-container>
        </div>
      </tx-loader-wrapper>
    </div>
  </div>
</div>
